import useAuth from "@hooks/useAuth";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

const ShareLinksDropdown = () => {
  const { user } = useAuth();

  const navigate = useNavigate();

  const [selectedLinkId, setSelectedLinkId] = useState(null);

  useEffect(() => {
    const selectedLink =
      shared_links.find(({ url }) => url === window.location.href) ||
      shared_links[0];

    setSelectedLinkId(selectedLink.id);
  }, []);

  const { shared_links } = user;

  const handleLinkChange = async (id) => {
    const link = shared_links.find((link) => link.id === parseInt(id, 10));

    console.log("ID", id, link);

    const parts = link.url.split(window.location.host);

    navigate(`${parts[1]}`);
  };

  const selectedLink =
    shared_links.find(({ id }) => id === selectedLinkId) || shared_links[0];

  return (
    <select
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => handleLinkChange(e.target.value)}
      value={selectedLink.id}
      className="w-full appearance-none bg-transparent pl-6 pr-6 py-1 text-sm cursor-pointer focus:outline-none"
    >
      {shared_links.map((link) => (
        <option key={link.id} value={link.id} className="text-dark_night_sky">
          {link.name}
        </option>
      ))}
    </select>
  );
};

export default ShareLinksDropdown;
